import { selectHasReadOnAnyEnvInSelectedOrg } from "@app/deploy";
import { useSelector } from "@app/react";
import { securityControlsUrl } from "@app/routes";

export function useSecurityControlsNav() {
  const canAccess = useSelector(selectHasReadOnAnyEnvInSelectedOrg);
  return { canAccess, destination: securityControlsUrl() };
}
